(() => {
  // themes/test-store-local-20260914/source/tora-specs.mjs
  var TORA_MANUAL = "https://cdn.shopify.com/s/files/1/0831/6482/3865/files/Luxsol_Tora_Pergola_Instructions_Season_3.pdf?v=1783941084";
  var common = { height: 2.523, underside: 2.33, post: 0.15, foot: 0.21, railHeight: 0.19, railDepth: 0.125, louvreWidth: 0.16, louvreHeight: 0.04 };
  var entries = {
    "4x4": { front: 4065, side: 4065, clearFront: 3705, clearSide: 3705, louvres: 27, litLouvres: 5, page: 3 },
    "5x3": { front: 5060, side: 3024, clearFront: 4700, clearSide: 2664, louvres: 34, litLouvres: 6, page: 4 },
    "5x4": { front: 5060, side: 4065, clearFront: 4700, clearSide: 3705, louvres: 34, litLouvres: 6, page: 4 },
    "6x3": { front: 5838, side: 3024, clearFront: 5478, clearSide: 2664, louvres: 39, litLouvres: 7, page: 5 },
    "6x4": { front: 5838, side: 4065, clearFront: 5478, clearSide: 3705, louvres: 39, litLouvres: 7, page: 5 },
    "8x4": { front: 7920, side: 4065, clearFront: 3705, clearSide: 3705, louvres: 54, litLouvres: 10, approximate: true, bays: 2 }
  };
  var TORA_SPECS = Object.fromEntries(Object.entries(entries).map(([size, e]) => [size, Object.freeze({ ...common, ...e, bays: e.bays || 1, width: (e.front - 60) / 1e3, depth: (e.side - 60) / 1e3, source: e.approximate ? "Two shared-post 4m bays; exact 8\xD74 drawing not published" : TORA_MANUAL })]));
  var TORA_DIMENSIONS = Object.fromEntries(Object.entries(TORA_SPECS).map(([size, s]) => [size, { front: s.front, side: s.side, height: 2523, clearFront: s.clearFront, clearSide: s.clearSide, approximate: Boolean(s.approximate), footprint: true }]));

  // themes/test-store-local-20260914/source/config.mjs
  var SIDES = ["front", "back", "left", "right"];
  var TORA_DOUBLE_BAY_SIDES = ["front-1", "front-2", "back-1", "back-2", "left", "right"];
  var TYPES = ["open", "screen", "electric-screen", "slatted"];
  var ROOFS = ["open", "tilted", "closed"];
  var FAMILY_SIZES = { aura: ["3x3", "3x4"], como: ["3x3", "3x4"], tora: ["4x4", "5x3", "5x4", "6x3", "6x4", "8x4"] };
  var SIZES = [...new Set(Object.values(FAMILY_SIZES).flat())];
  var SCENES = ["studio", "garden", "house", "evening", "night"];
  var familySizes = (family) => FAMILY_SIZES[family] || FAMILY_SIZES.aura;
  var modelLabel = (c) => ({ aura: "Aura", como: "Como", tora: "Tora" })[c.family || "aura"];
  var isElectric = (c) => ["como", "tora"].includes(typeof c === "string" ? c : c.family);
  var sidesFor = (c) => c.family === "tora" && c.size === "8x4" ? TORA_DOUBLE_BAY_SIDES : SIDES;
  var physicalSide = (side) => side.split("-")[0];
  var accessorySize = (size, side) => {
    const dimensions = size.split("x").map(Number);
    return size === "8x4" ? 4 : ["front", "back"].includes(physicalSide(side)) ? Math.max(...dimensions) : Math.min(...dimensions);
  };
  function compatibleSideTypes(config, side) {
    if (!sidesFor(config).includes(side)) return [];
    return [3, 4].includes(accessorySize(config.size, side)) ? [...TYPES] : ["open", "electric-screen"];
  }
  function allowedSideTypes(config, side) {
    return compatibleSideTypes(config, side).filter((type) => config.family !== "aura" || type !== "electric-screen");
  }
  var defaultConfig = (family = "aura") => ({ family, ...isElectric(family) ? { roofAngle: 65, light: 0, ...family === "tora" ? { whiteLight: 0, rgbColor: "#ffad66" } : {} } : {}, scene: "studio", size: family === "como" ? "3x4" : familySizes(family)[0], roof: "open", view: "front", heater: false, heaterQuantity: 0, heaterGlow: false, heaterLevel: 0, sides: Object.fromEntries(SIDES.map((s) => [s, "open"])), drops: Object.fromEntries(SIDES.map((s) => [s, 1])) });
  function normalize(input) {
    if (!input || typeof input !== "object") throw Error("Invalid configuration");
    const family = input.family || "aura";
    if (!Object.hasOwn(FAMILY_SIZES, family)) throw Error("Invalid pergola model");
    const d = defaultConfig(family);
    d.size = input.size ?? d.size;
    if (!familySizes(family).includes(d.size)) throw Error(`Invalid ${modelLabel(d)} size`);
    d.scene = input.scene ?? "studio";
    if (["patio", "courtyard", "modern", "cottage", "deck", "coastal"].includes(d.scene)) d.scene = "garden";
    if (!SCENES.includes(d.scene)) throw Error("Invalid background scene");
    if (!ROOFS.includes(input.roof) || !["front", "rear"].includes(input.view) || typeof input.heater !== "boolean") throw Error("Invalid roof, view or heater");
    d.roof = input.roof;
    d.view = input.view;
    const heaterQuantity = input.heaterQuantity > 0 ? input.heaterQuantity : input.heater ? family === "tora" ? 2 : 1 : input.heaterQuantity ?? 0;
    if (!Number.isSafeInteger(heaterQuantity) || heaterQuantity < 0) throw Error("Invalid heater quantity.");
    d.heaterQuantity = heaterQuantity;
    d.heater = heaterQuantity > 0;
    d.heaterLevel = [0, 750, 1500, 2e3].includes(Number(input.heaterLevel)) ? Number(input.heaterLevel) : input.heaterGlow ? 2e3 : 0;
    d.heaterGlow = d.heaterLevel > 0;
    if (isElectric(d)) {
      d.roofAngle = input.roofAngle ?? { open: 65, tilted: 32, closed: 0 }[d.roof];
      d.light = input.light ?? 0;
      if (!Number.isFinite(d.roofAngle) || d.roofAngle < 0 || d.roofAngle > 65 || !Number.isFinite(d.light) || d.light < 0 || d.light > 100) throw Error("Invalid electric preview settings");
    }
    if (family === "tora") {
      d.whiteLight = input.whiteLight ?? input.light ?? 0;
      d.rgbColor = input.rgbColor ?? "#ffad66";
      d.rgbFlow = false;
      if (!Number.isFinite(d.whiteLight) || d.whiteLight < 0 || d.whiteLight > 100 || !/^#[0-9a-fA-F]{6}$/.test(d.rgbColor)) throw Error("Invalid Tora lighting settings");
    }
    d.sides = {};
    d.drops = {};
    for (const side of sidesFor(d)) {
      const legacy = physicalSide(side), type = input.sides?.[side] ?? input.sides?.[legacy], drop = input.drops?.[side] ?? input.drops?.[legacy] ?? 1;
      if (!TYPES.includes(type) || !allowedSideTypes(d, side).includes(type) || ![0, 0.5, 1].includes(drop)) throw Error("Invalid side selection");
      d.sides[side] = type;
      d.drops[side] = ["screen", "electric-screen"].includes(type) ? drop : 1;
    }
    return d;
  }

  // themes/test-store-local-20260914/source/installation-pricing.mjs
  var INSTALLATION_BASE_FEES = Object.freeze({
    aura: Object.freeze({ "3x3": 11e4, "3x4": 11e4 }),
    como: Object.freeze({ "3x3": 11e4, "3x4": 11e4 }),
    tora: Object.freeze({ "4x4": 155e3, "5x3": 155e3, "5x4": 18e4, "6x3": 18e4, "6x4": 18e4, "8x4": 3e5 })
  });
  var INSTALLATION_SERVICE_PRODUCT = Object.freeze({
    id: 15986174329205,
    handle: "luxsol-configurator-installation-services",
    status: "UNLISTED"
  });
  var INSTALLATION_SERVICE_VARIANTS = Object.freeze({
    "base-aura-como": Object.freeze({ id: 57581269680501, sku: "LS-INSTALL-AC-1100", price: 11e4 }),
    "base-tora-1550": Object.freeze({ id: 57581269713269, sku: "LS-INSTALL-TORA-1550", price: 155e3 }),
    "base-tora-1800": Object.freeze({ id: 57581269746037, sku: "LS-INSTALL-TORA-1800", price: 18e4 }),
    "base-tora-3000": Object.freeze({ id: 57581269778805, sku: "LS-INSTALL-TORA-3000", price: 3e5 }),
    "manual-screen-fitting": Object.freeze({ id: 57581269811573, sku: "LS-INSTALL-MANUAL-100", price: 1e4 }),
    "electric-screen-fitting": Object.freeze({ id: 57593891520885, sku: "LS-INSTALL-ELECTRIC-200", price: 2e4 }),
    "slatted-wall-fitting": Object.freeze({ id: 57593891553653, sku: "LS-INSTALL-SLATTED-200", price: 2e4 }),
    "heater-fitting": Object.freeze({ id: 57581269844341, sku: "LS-INSTALL-HEATER-15", price: 1500 }),
    "surface-4post": Object.freeze({ id: 57581269877109, sku: "LS-INSTALL-SURFACE-4POST-200", price: 2e4 }),
    "surface-6post": Object.freeze({ id: 57593891586421, sku: "LS-INSTALL-SURFACE-6POST-250", price: 25e3 }),
    "packaging-removal": Object.freeze({ id: 57601399226741, sku: "LS-INSTALL-PACKAGING-75", price: 7500 })
  });
  var ACCESSORY_FEES = Object.freeze({
    screen: { price: 1e4, label: "Manual screen installation", serviceKey: "manual-screen-fitting" },
    "electric-screen": { price: 2e4, label: "Electric screen installation", serviceKey: "electric-screen-fitting" },
    slatted: { price: 2e4, label: "Slatted wall installation", serviceKey: "slatted-wall-fitting" },
    heater: { price: 1500, label: "Heater fitting" },
    surface4: { price: 2e4, label: "Porcelain / granite surcharge \xB7 4 posts", serviceKey: "surface-4post" },
    surface6: { price: 25e3, label: "Porcelain / granite surcharge \xB7 6 posts", serviceKey: "surface-6post" },
    packaging: { price: 7500, label: "Packaging removal", serviceKey: "packaging-removal" }
  });
  function installationBaseFee(family, size) {
    if (!Object.hasOwn(INSTALLATION_BASE_FEES, family)) throw Error("No installation fee for this model and size.");
    const fees = INSTALLATION_BASE_FEES[family];
    if (!fees || !Object.hasOwn(fees, size)) throw Error("No installation fee for this model and size.");
    return fees[size];
  }
  function installationBaseServiceKey(family, size) {
    if (family === "aura" || family === "como") return "base-aura-como";
    if (family === "tora" && ["4x4", "5x3"].includes(size)) return "base-tora-1550";
    if (family === "tora" && ["5x4", "6x3", "6x4"].includes(size)) return "base-tora-1800";
    if (family === "tora" && size === "8x4") return "base-tora-3000";
    throw Error("No Shopify installation service variant for this model and size.");
  }
  function quoteInstallation(input, options = {}) {
    if (!options || typeof options !== "object" || Array.isArray(options)) throw Error("Invalid installation options.");
    const config = normalize(input);
    const { surface = "standard", packagingRemoval = false } = options;
    if (!["standard", "porcelain-granite"].includes(surface)) throw Error("Invalid installation surface.");
    if (typeof packagingRemoval !== "boolean") throw Error("Invalid packaging removal selection.");
    const heaterQuantity = options.heaterQuantity === void 0 ? config.heaterQuantity : options.heaterQuantity;
    if (!Number.isSafeInteger(heaterQuantity) || heaterQuantity < 0) throw Error("Invalid heater installation quantity.");
    if (heaterQuantity !== config.heaterQuantity) throw Error("Heater installation quantity does not match the build selection.");
    const postCount = config.family === "tora" && config.size === "8x4" ? 6 : 4;
    const items = [];
    function add(code, label, unitPriceMinor, quantity = 1, details = {}, serviceKey = code) {
      const totalMinor2 = unitPriceMinor * quantity;
      if (!Number.isSafeInteger(totalMinor2) || totalMinor2 < 0) throw Error("Installation amount exceeds the supported range.");
      const service = INSTALLATION_SERVICE_VARIANTS[serviceKey];
      if (!service || service.price !== unitPriceMinor) throw Error(`Invalid Shopify installation service mapping: ${serviceKey}.`);
      items.push({ code, label, quantity, unitPriceMinor, totalMinor: totalMinor2, variantId: service.id, sku: service.sku, productHandle: INSTALLATION_SERVICE_PRODUCT.handle, productStatus: INSTALLATION_SERVICE_PRODUCT.status, ...details });
    }
    add("pergola-installation", `${config.family[0].toUpperCase() + config.family.slice(1)} ${config.size.replace("x", " \xD7 ")}m installation`, installationBaseFee(config.family, config.size), 1, {}, installationBaseServiceKey(config.family, config.size));
    for (const side of sidesFor(config)) {
      const type = config.sides[side];
      if (type === "open") continue;
      const fee = ACCESSORY_FEES[type];
      const size = accessorySize(config.size, side);
      if (fee) add(`${type}-installation`, `${fee.label} \xB7 ${size}m`, fee.price, 1, { side, accessorySize: size }, fee.serviceKey);
    }
    if (surface === "porcelain-granite") {
      const fee = postCount === 6 ? ACCESSORY_FEES.surface6 : ACCESSORY_FEES.surface4;
      add("porcelain-granite-surcharge", fee.label, fee.price, 1, { postCount }, fee.serviceKey);
    }
    if (heaterQuantity) add("heater-fitting", ACCESSORY_FEES.heater.label, ACCESSORY_FEES.heater.price, heaterQuantity, {}, "heater-fitting");
    if (packagingRemoval) add("packaging-removal", ACCESSORY_FEES.packaging.label, ACCESSORY_FEES.packaging.price, 1, {}, ACCESSORY_FEES.packaging.serviceKey);
    const totalMinor = items.reduce((sum, item) => sum + item.totalMinor, 0);
    if (!Number.isSafeInteger(totalMinor)) throw Error("Installation amount exceeds the supported range.");
    return { currency: "GBP", family: config.family, size: config.size, postCount, surface, heaterQuantity, packagingRemoval, items, totalMinor, serviceProduct: INSTALLATION_SERVICE_PRODUCT, serviceVariantsConnected: true, checkoutEnabled: ["ACTIVE", "UNLISTED"].includes(INSTALLATION_SERVICE_PRODUCT.status) };
  }

  // themes/test-store-local-20260914/source/shopify/installation-step.mjs
  var UK_POSTCODE = /^(?:GIR\s?0AA|[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2})$/i;
  var normalisePostcode = (value) => {
    const compact = String(value || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
    return UK_POSTCODE.test(compact) ? `${compact.slice(0, -3)} ${compact.slice(-3)}` : null;
  };

  // themes/test-store-local-20260914/source/shopify/installation-coverage.mjs
  var EARTH_RADIUS_MILES = 3958.7613;
  function straightLineMiles(first, second) {
    const radians = (value) => value * Math.PI / 180;
    const latitudeChange = radians(second.latitude - first.latitude);
    const longitudeChange = radians(second.longitude - first.longitude);
    const a = Math.sin(latitudeChange / 2) ** 2 + Math.cos(radians(first.latitude)) * Math.cos(radians(second.latitude)) * Math.sin(longitudeChange / 2) ** 2;
    return 2 * EARTH_RADIUS_MILES * Math.asin(Math.min(1, Math.sqrt(a)));
  }
  async function lookupPostcodeCoordinates(postcode) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 5e3);
    try {
      const response = await fetch(`https://api.postcodes.io/postcodes/${encodeURIComponent(postcode.replace(" ", ""))}`, { signal: controller.signal });
      if (!response.ok) return null;
      const data = (await response.json()).result;
      if (normalisePostcode(data?.postcode) !== postcode) return null;
      const latitude = Number(data.latitude), longitude = Number(data.longitude);
      if (!Number.isFinite(latitude) || Math.abs(latitude) > 90 || !Number.isFinite(longitude) || Math.abs(longitude) > 180) return null;
      return { latitude, longitude };
    } catch {
      return null;
    } finally {
      clearTimeout(timeout);
    }
  }
  function createInstallationCoverage({ showroomPostcode = "CW11 3JA", radiusMiles = 60, lookup = lookupPostcodeCoordinates } = {}) {
    const originPostcode = normalisePostcode(showroomPostcode);
    const radius = Number(radiusMiles);
    let originPromise = null;
    const getOrigin = () => {
      if (!originPromise) originPromise = Promise.resolve(lookup(originPostcode)).then((point) => {
        if (!point) originPromise = null;
        return point;
      }, () => {
        originPromise = null;
        return null;
      });
      return originPromise;
    };
    return async ({ postcode }) => {
      const destinationPostcode = normalisePostcode(postcode);
      if (!originPostcode || !destinationPostcode || !Number.isFinite(radius) || radius <= 0) return { status: "review", reason: "unconfirmed", radiusMiles: radius };
      const [origin, destination] = await Promise.all([getOrigin(), lookup(destinationPostcode)]);
      if (!origin || !destination) return { status: "review", reason: "unconfirmed", radiusMiles: radius };
      const distanceMiles = straightLineMiles(origin, destination);
      if (distanceMiles <= radius) return { status: "available", radiusMiles: radius, distanceMiles };
      return { status: "review", reason: "outside", radiusMiles: radius, distanceMiles };
    };
  }

  // cart-builder-match-20260929/installation-core.mjs
  var checkInstallationCoverage = createInstallationCoverage({ showroomPostcode: "CW11 3JA", radiusMiles: 60 });
  var installationVariantIds = new Set(Object.values(INSTALLATION_SERVICE_VARIANTS).map((v) => v.id));
  async function prepareInstallationItems({ items, selection, family, size, build, root = "/" }, { coverage = checkInstallationCoverage, fetchProduct = async () => {
    const response = await fetch(root + "products/" + INSTALLATION_SERVICE_PRODUCT.handle + ".js", { cache: "no-store", headers: { Accept: "application/json" } });
    if (!response.ok) throw Error("Installation availability could not be checked. Please try again.");
    return response.json();
  } } = {}) {
    if (selection.choice !== "professional") return items;
    if (!selection.complete) throw Error("Choose an installation option before continuing.");
    const postcode = normalisePostcode(selection.postcode);
    if (!postcode || selection.coverageStatus !== "available") throw Error("Check your installation postcode before continuing.");
    if (selection.baseConfirmationRequired !== false && !selection.baseConfirmed) throw Error("Confirm your installation base before continuing.");
    const checked = await coverage({ postcode });
    if (checked.status !== "available") throw Error("We could not confirm your installation area. Check your postcode again or choose another installation option.");
    selection = { ...selection, postcode };
    const quote = quoteInstallation(build, { surface: selection.surface, packagingRemoval: selection.packagingRemoval });
    if (quote.totalMinor !== selection.quote?.totalMinor) throw Error("Your installation choices changed. Review them before adding your build.");
    const product = await fetchProduct();
    if (product.id !== INSTALLATION_SERVICE_PRODUCT.id || product.requires_selling_plan) throw Error("Installation services have changed. Please contact LuxSol.");
    for (const line of quote.items) {
      const variant = product.variants.find((v) => v.id === line.variantId && v.sku === line.sku);
      if (!variant || !variant.available || variant.requires_selling_plan || variant.price !== line.unitPriceMinor) throw Error("Installation pricing or availability has changed. Please contact LuxSol before ordering.");
    }
    const base = items.find((i) => !i.properties?.Position);
    if (!base) throw Error("Your pergola could not be identified.");
    const name = Object.keys(base.properties).find((k) => ["Aura build", "Como build", "Tora build"].includes(k));
    if (!name || !base.properties[name]) throw Error("Your configuration could not be identified.");
    const properties = { ...base.properties, Installation: "Installed by LuxSol", "Installation area": selection.postcode ? "Postcode checked" : "To confirm with LuxSol", ...(selection.postcode ? {"Installation postcode": selection.postcode} : {}), "Installation surface": selection.surface === "porcelain-granite" ? "Porcelain / granite" : "Standard prepared base", "Packaging removal": selection.packagingRemoval ? "Included" : "Not selected" };
    return [...items.map((i) => i === base ? { ...i, properties } : i), ...quote.items.map((line) => ({ id: line.variantId, quantity: line.quantity, properties: { [name]: properties[name], Position: "Installation:" + line.code + (line.side ? ":" + line.side : ""), "_Installation service": line.code, "Service": line.label, ...(selection.postcode ? {"Installation postcode": selection.postcode} : {}) } }))];
  }

  // cart-builder-match-20260929/edit-core.mjs
  var installationIds = new Set(Object.values(INSTALLATION_SERVICE_VARIANTS).map((v) => v.id));
  var models = { "Aura build": { id: 15986073960821, family: "aura" }, "Como build": { id: 15986073993589, family: "como" }, "Tora build": { id: 15986074026357, family: "tora" } };
  var sides = { Front: "front", Rear: "back", Left: "left", Right: "right", "Front 1": "front-1", "Front 2": "front-2", "Rear 1": "back-1", "Rear 2": "back-2" };
  var slot = (item) => item.properties?.Position || "base";
  var plan = (item) => item.selling_plan_allocation?.selling_plan?.id || null;
  var signature = (items) => JSON.stringify(items.map((i) => ({ key: i.key, id: i.variant_id, quantity: i.quantity, properties: i.properties, plan: plan(i) })).sort((a, b) => a.key.localeCompare(b.key)));
  function readBuild(cart, name, value) {
    const model = models[name];
    if (!model || !value) throw Error("This configuration cannot be edited.");
    const items = cart.items.filter((i) => i.properties?.[name] === value);
    const bases = items.filter((i) => !i.properties?.Position);
    const base = bases[0];
    if (bases.length !== 1 || base.quantity !== 1 || Number(base.product_id) !== model.id || !base.properties?.Size || items.some((i) => Object.keys(models).filter((k) => i.properties?.[k]).length !== 1)) throw Error("Your configuration has changed. Reopen your bag to review it.");
    const positions = /* @__PURE__ */ new Set();
    for (const i of items) {
      const p = slot(i);
      if (positions.has(p) || !Number.isInteger(i.quantity) || i.quantity < 1) throw Error("Review this configuration in your bag before editing.");
      if (p.startsWith("Installation:") ? Number(i.product_id) !== INSTALLATION_SERVICE_PRODUCT.id || !installationIds.has(Number(i.variant_id)) || !i.properties["_Installation service"] : p !== "base" && p !== "Accessory" && (!sides[p] || !base.properties[p] || base.properties[p] === "open")) throw Error("The configuration has an unrecognised component.");
      positions.add(p);
    }
    for (const label of Object.keys(sides)) {
      const type = base.properties[label];
      if (type && (!["open", "screen", "electric-screen", "slatted"].includes(type) || type !== "open" !== positions.has(label))) throw Error("The configuration is incomplete. Please review your bag.");
    }
    return { name, value, family: model.family, base, items, signature: signature(items) };
  }
  function savedBuild(build) {
    const size = build.base.properties.Size.replace(/[^0-9×x]/g, "").replace("\xD7", "x");
    const selected = {};
    for (const [label, key] of Object.entries(sides)) if (build.base.properties[label]) selected[key] = build.base.properties[label];
    const heaterQuantity = build.items.filter((i) => slot(i) === "Accessory").reduce((n, i) => n + i.quantity, 0);
    return { version: 1, family: build.family, savedAt: Date.now(), config: { size, sides: selected, heaterQuantity, roof: "open", roofAngle: 65, light: 0, whiteLight: 0, rgbColor: "#ffad66" }, preview: { evening: false, heaterGlow: false, drops: {} }, step: "review", side: "front", workspace: false, selfInstall: build.base.properties.Installation === "Self-installation" };
  }
  async function replaceBuild({ context, items, read, post }) {
    let before = readBuild(await read(), context.name, context.value);
    if (before.signature !== context.signature) throw Error("This build changed in another view. Reopen your bag before saving.");
    const plans = new Set(before.items.map(plan));
    if (plans.size !== 1) throw Error("Choose one payment option in your bag before editing.");
    const sellingPlan = [...plans][0];
    const target = items.map((i) => ({ ...i, properties: { ...i.properties, [context.name]: context.value }, selling_plan: sellingPlan }));
    if (target.length < 1 || target.filter((i) => !i.properties.Position).length !== 1 || target.some((i) => !Number.isSafeInteger(i.id) || !Number.isInteger(i.quantity) || i.quantity < 1)) throw Error("The replacement configuration is invalid.");
    const wanted = new Map(target.map((i) => [slot(i), i]));
    if (wanted.size !== target.length) throw Error("Duplicate configuration positions.");
    const belonging = (cart) => cart.items.filter((i) => i.properties?.[context.name] === context.value);
    const sameProps = (a, b) => JSON.stringify(Object.entries(a || {}).sort()) === JSON.stringify(Object.entries(b || {}).sort());
    const matches = (actual, desired) => actual.length === desired.length && desired.every((t) => actual.some((a) => slot(a) === slot(t) && a.variant_id === t.id && a.quantity === t.quantity && plan(a) === (t.selling_plan || null) && sameProps(a.properties, t.properties)));
    async function reconcile(desired) {
      let cart = await read();
      let actual = belonging(cart);
      const added = desired.filter((t) => !actual.some((a) => slot(a) === slot(t) && a.variant_id === t.id));
      if (added.length) {
        await post("add", { items: added });
        cart = await read();
        actual = belonging(cart);
      }
      for (const t of desired) {
        const a = actual.find((a2) => slot(a2) === slot(t) && a2.variant_id === t.id);
        if (!a) throw Error("The updated item could not be confirmed.");
        if (a.quantity !== t.quantity || !sameProps(a.properties, t.properties) || plan(a) !== (t.selling_plan || null)) {
          await post("change", { line: cart.items.findIndex((i) => i.key === a.key) + 1, quantity: t.quantity, properties: t.properties, selling_plan: t.selling_plan });
          cart = await read();
          actual = belonging(cart);
        }
      }
      const remove = actual.filter((a) => !desired.some((t) => slot(a) === slot(t) && a.variant_id === t.id));
      if (remove.length) await post("update", { updates: Object.fromEntries(remove.map((a) => [a.key, 0])) });
      cart = await read();
      if (!matches(belonging(cart), desired)) throw Error("The saved configuration could not be verified.");
      return cart;
    }
    try {
      return await reconcile(target);
    } catch (error) {
      const restore = before.items.map((i) => ({ id: i.variant_id, quantity: i.quantity, properties: i.properties, selling_plan: plan(i) }));
      try {
        const restored = await reconcile(restore);
        error.restored = true;
        error.restoredSignature = signature(belonging(restored));
      } catch {
        error.restored = false;
      }
      throw error;
    }
  }

  // cart-builder-match-20260929/add-core.mjs
  async function addBuild({ items, read, post }) {
    const names = Object.keys(models).filter((name2) => items[0]?.properties?.[name2]);
    if (names.length !== 1) throw Error("The configuration is invalid. Reload the builder.");
    const name = names[0], value = items[0].properties[name];
    if (!value || items.some((i) => i.properties?.[name] !== value)) throw Error("The configuration is invalid. Reload the builder.");
    const belonging = (cart2) => cart2.items.filter((i) => i.properties?.[name] === value);
    if (belonging(await read()).length) throw Error("This build is already in your bag. Please review it before adding again.");
    let failure;
    try {
      await post("add", { items });
    } catch (error) {
      failure = error;
    }
    let cart;
    try {
      cart = await read();
    } catch {
      throw Object.assign(Error("The basket could not be verified. Check your bag and reload before adding again."), { uncertain: true });
    }
    const actual = belonging(cart);
    const props = (p) => JSON.stringify(Object.entries(p || {}).filter(([, v]) => v !== "" && v != null).sort(([a], [b]) => a.localeCompare(b)));
    const matches = actual.length === items.length && items.every((t) => actual.some((a) => a.variant_id === t.id && a.quantity === t.quantity && props(a.properties) === props(t.properties)));
    if (matches) return cart;
    if (actual.length) {
      try {
        await post("update", { updates: Object.fromEntries(actual.map((i) => [i.key, 0])) });
        if (belonging(await read()).length) throw Error("Incomplete rollback");
      } catch {
        throw Object.assign(Error("The build could not be added completely. Please check your bag and contact LuxSol before trying again."), { uncertain: true });
      }
    }
    const reason = /availability|stock|sold out|Only \d+ items/i.test(failure?.message || "") ? "The selected quantities are not available." : failure?.message || "The selected quantities are not available.";
    throw Error(reason + " Your build was not added. Your existing bag is unchanged. Reduce the quantity or change your options before trying again.");
  }

  async function removeBuild({ name, value, read, post, sections = [] }) {
    if (!models[name] || !value) throw Error("This configuration could not be identified. Reload your bag.");
    const before = await read();
    const members = before.items.filter((item) => item.properties?.[name] === value);
    const bases = members.filter((item) => !item.properties?.Position);
    if (bases.length !== 1 || Number(bases[0].product_id) !== models[name].id || members.some((item) => !item.key || Object.keys(models).filter((key) => item.properties?.[key]).length !== 1)) throw Error("Your configuration has changed. Reload your bag before removing it.");
    let result, failure;
    try {
      result = await post("update", { updates: Object.fromEntries(members.map((item) => [item.key, 0])), sections });
    } catch (error) {
      failure = error;
    }
    const after = await read();
    if (after.items.some((item) => item.properties?.[name] === value)) throw failure || Error("Your configuration could not be removed. Reload your bag and try again.");
    return { ...after, sections: result?.sections };
  }

  // cart-builder-match-20260929/controller.mjs
  (() => {
    window.luxsolInstallationCoverage = checkInstallationCoverage;
    window.luxsolPrepareInstallationItems = prepareInstallationItems;
    if (window.luxsolConfigurationCartReady) return;
    window.luxsolConfigurationCartReady = true;
    const root = () => window.Shopify?.routes?.root || "/";
    const key = "luxsol:cart-edit:v1", lock = "luxsol:cart-edit-pending:v1";
    let busy = false;
    const read = async () => {
      const r = await fetch(root() + "cart.js", { cache: "no-store", credentials: "same-origin", headers: { Accept: "application/json" } });
      if (!r.ok) throw Error("Your bag could not be checked. Please try again.");
      return r.json();
    };
    window.luxsolPrepareConfigurationCart = async (cartRoot = root(), cart) => {
      await customElements.whenDefined("cart-drawer");
      const drawer = document.getElementById("cart-drawer");
      if (!drawer) throw Error("Your build is in your bag, but the bag could not open. Please reload before adding again.");
      const section = drawer.closest(".shopify-section")?.id.replace("shopify-section-", "") || "cart-drawer";
      const response = await fetch(cartRoot + "?sections=" + encodeURIComponent(section), { cache: "no-store", credentials: "same-origin", headers: { Accept: "application/json" } });
      if (!response.ok) throw Error("Your build is in your bag. Please reload to view it before adding again.");
      const sections = await response.json();
      if (!sections[section] || !new DOMParser().parseFromString(sections[section], "text/html").querySelector("#cart-drawer")) throw Error("Your build is in your bag. Please reload to view it before adding again.");
      cart || (cart = await read());
      cart.sections = sections;
      return () => {
        document.documentElement.dispatchEvent(new CustomEvent("cart:change", { bubbles: true, detail: { baseEvent: "variant:add", cart } }));
        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true, detail: { cart } }));
        drawer.show();
      };
    };
    window.luxsolOpenConfigurationCart = async (cartRoot = root()) => {
      try {
        (await window.luxsolPrepareConfigurationCart(cartRoot))();
      } catch (error) {
        const host = document.querySelector("aura-builder");
        const feedback = host?.shadowRoot?.querySelector("#feedback");
        if (feedback) feedback.textContent = error.message;
      }
    };
    const post = async (action, body) => {
      const r = await fetch(root() + "cart/" + action + ".js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) });
      const json = await r.json();
      if (!r.ok || json.status) throw Error(json.description || json.message || "Your configuration could not be saved.");
      return json;
    };
    window.luxsolAddConfigurationItems = async (cartRoot, items) => addBuild({ items, read, post });
    const locked = () => {
      try {
        return busy || Boolean(sessionStorage.getItem(lock));
      } catch {
        return busy;
      }
    };
    document.addEventListener("submit", (event) => {
      if (locked() && event.target.matches?.('form[action*="/cart"],form[action*="/checkout"]')) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
    document.addEventListener("click", (event) => {
      if (locked() && event.target.closest?.('[name=checkout],[href*="/checkout"],line-item-quantity,[data-luxsol-edit-build],[data-luxsol-remove-build]')) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
    document.addEventListener("click", async (event) => {
      const button = event.target.closest?.("[data-luxsol-remove-build]");
      if (!button) return;
      event.preventDefault();
      if (locked() || button.disabled || button.closest("[data-payment-busy]")) return;
      busy = true;
      button.disabled = true;
      button.setAttribute("aria-busy", "true");
      const errorNode = button.closest(".lcd-build").querySelector(".lcd-build__error");
      errorNode.hidden = true;
      window.luxsolDraftCartPaymentReady = false;
      try {
        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections } }));
        const cart = await removeBuild({ name: button.dataset.buildName, value: button.dataset.buildValue, read, post, sections: [...new Set(sections)].slice(0, 5) });
        if (location.pathname.replace(/\/$/, "").endsWith("/cart") || !sections.length || sections.some((section) => !cart.sections?.[section])) {
          location.reload();
          return;
        }
        document.documentElement.dispatchEvent(new CustomEvent("cart:change", { bubbles: true, detail: { baseEvent: "line-item:change", cart } }));
        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true, detail: { cart } }));
      } catch (error) {
        errorNode.textContent = error.message;
        errorNode.hidden = false;
        button.disabled = false;
        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));
      } finally {
        busy = false;
        button.removeAttribute("aria-busy");
      }
    });
    document.addEventListener("click", async (event) => {
      const link = event.target.closest?.("[data-luxsol-edit-build]");
      if (!link || busy) return;
      event.preventDefault();
      busy = true;
      link.setAttribute("aria-busy", "true");
      try {
        const build = readBuild(await read(), link.dataset.buildName, link.dataset.buildValue);
        localStorage.setItem("luxsol:unfinished-build:v1:" + build.family, JSON.stringify(savedBuild(build)));
        sessionStorage.setItem(key, JSON.stringify({ name: build.name, value: build.value, signature: build.signature }));
        location.assign(link.href);
      } catch (error) {
        const node = link.closest(".lcd-build").querySelector(".lcd-build__error");
        node.textContent = error.message;
        node.hidden = false;
      } finally {
        busy = false;
        link.removeAttribute("aria-busy");
      }
    });
    window.luxsolSaveCartEdit = async ({ builder, items, config }) => {
      const context = builder.luxsolCartEdit;
      if (!context) throw Error("Reopen this configuration from your bag.");
      if (busy) throw Error("Your changes are already being saved.");
      busy = true;
      sessionStorage.setItem(lock, context.value);
      window.luxsolDraftCartPaymentReady = false;
      try {
        await replaceBuild({ context, items, read, post });
        sessionStorage.removeItem(lock);
        sessionStorage.removeItem(key);
        delete builder.luxsolCartEdit;
        return () => location.assign(config.root + "?luxsol_cart=1");
      } catch (error) {
        if (error.restored) {
          context.signature = error.restoredSignature;
          sessionStorage.setItem(key, JSON.stringify(context));
          sessionStorage.removeItem(lock);
        }
        throw Error(error.restored ? "Your changes were not saved. Your original build is still in your bag. " + error.message : "Your changes could not be verified. Checkout is paused; please contact LuxSol before proceeding.");
      } finally {
        busy = false;
      }
    };
    const editValue = new URLSearchParams(location.search).get("luxsol_edit");
    async function initialise() {
      if (new URLSearchParams(location.search).has("luxsol_cart")) customElements.whenDefined("cart-drawer").then(() => document.querySelector("#cart-drawer")?.show?.());
      if (!editValue) return;
      try {
        const cart = await read();
        const base = cart.items.find((i) => !i.properties?.Position && Object.keys(models).some((n) => i.properties?.[n] === editValue));
        if (!base) throw Error("This build is no longer in your bag.");
        const name = Object.keys(models).find((n) => base.properties?.[n] === editValue);
        const context = readBuild(cart, name, editValue);
        let saved;
        try {
          saved = JSON.parse(sessionStorage.getItem(key));
        } catch {
        }
        ;
        if (saved?.value === context.value && saved.signature !== context.signature) throw Error("This configuration changed. Reopen it from your bag before editing.");
        const builder = document.querySelector("aura-builder");
        if (!builder) throw Error("The product builder is unavailable.");
        const fail = (message) => {
          const p = document.createElement("p");
          p.textContent = message;
          p.setAttribute("role", "alert");
          builder.before(p);
        };
        let count = 0;
        const mount = () => {
          try {
            if (!builder.instance || !builder.shadowRoot?.querySelector("[data-basket]") || builder.querySelector("[data-luxsol-renderer-config]") && !builder.shadowRoot.querySelector(".lx-renderer-pdp")) {
              if (count++ < 100) setTimeout(mount, 100);
              else fail("The builder could not load your choices. Reopen the configuration from your bag.");
              return;
            }
            const family = builder.instance.getState().family;
            if (family !== context.family) throw Error("Open this configuration on its matching product page.");
            const expected = savedBuild(context);
            const correct = () => {
              const st = builder.instance.getState();
              return st.size === expected.config.size && st.heaterQuantity === expected.config.heaterQuantity && Object.entries(expected.config.sides).every(([side, type]) => st.sides?.[side] === type);
            };
            if (!correct()) {
              const config = expected;
              const click = (sel) => {
                const b = builder.shadowRoot.querySelector(sel);
                if (b && !b.disabled) b.click();
              };
              click(`[data-size="${config.config.size}"]`);
              for (const [side, type] of Object.entries(config.config.sides)) {
                click(`[data-side="${side}"]`);
                click(`[data-type="${type}"]`);
              }
              let q = builder.instance.getState().heaterQuantity;
              for (; q < config.config.heaterQuantity; q++) click('[data-heater-adjust="1"]');
              for (; q > config.config.heaterQuantity; q--) click('[data-heater-adjust="-1"]');
              if (config.selfInstall) click('[data-install-choice="self"]');
            }
            if (!correct()) throw Error("Your choices could not be restored. Reopen this configuration from your bag.");
            builder.luxsolCartEdit = { name: context.name, value: context.value, signature: context.signature };
            sessionStorage.setItem(key, JSON.stringify(builder.luxsolCartEdit));
            const note = document.createElement("p");
            note.className = "lx-edit-context";
            note.textContent = "Editing your configuration. Your current build stays in your bag until you save.";
            note.style.cssText = "padding:12px 14px;border-radius:8px;background:#eff5f1;color:#214e43;font:12px/1.5 Arial;margin:12px 0";
            builder.shadowRoot.querySelector(".pdp-build-drawer")?.prepend(note);
            const update = () => {
              for (const b of builder.shadowRoot.querySelectorAll("[data-basket]")) if (!b.disabled && !/saving|adding/i.test(b.textContent) && b.textContent !== "Save changes") b.textContent = "Save changes";
            };
            update();
            new MutationObserver(update).observe(builder.shadowRoot, { subtree: true, childList: true, attributes: true, attributeFilter: ["disabled"] });
          } catch (error) {
            fail(error.message);
          }
        };
        mount();
      } catch (error) {
        const b = document.querySelector("aura-builder");
        const p = document.createElement("p");
        p.textContent = error.message;
        p.setAttribute("role", "alert");
        b?.before(p);
      }
    }
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initialise, { once: true });
    else initialise();
  })();
})();

